module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAARCAYAAAA2cze9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEtSURBVHgB1ZPNTcNAEIXfbByRo6kAd0A6CK6AUIFxB1xQ+DlMfADMyXSwpoO4AkgHlOAOyI0L8jC24hCQEylyfMiTVrt6Xn+787PEj3aMHlkIXLRTDhE/ug3z2nBgKDFCl3wTZGghfk4TCCW6vKg9o8NrC65USAb6G71BhzoYeC5E73uH84Md6uRRUcz5yZ7p8ErfQUtxbF9AFJDgo/ZEMNQD/dZwgM7xLf70PlzBp3FqyTGne0lL/6j/2eR33C2ERVkEdCDNuYRaEMtx6mFXfcnxVng0CWc6z7ZtqgqkPcyT4PX/N73Uxv86zTk1mczWxQDj1SbtY5QvUGReGYJFdFdFXEb1tvTzXyqx6dFVc58P4CpwtObky0NGa1eq4AoO1WddntSbC6KUr4PsB1QCYKAsD4KQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/website/images/lapIcon.png
// module id = 8Tr9
// module chunks = 1